<style lang="less">
@import "./OrderDetail.less";
.member-order-refund {
  display: flex;
  flex-direction: column;
  .order-product-list {
    flex: 0 0 100%;
    .order-product-list-header {
      flex: 0 0 100%;
    }
  }
  .member-order-list {
    .order-product-list {
      flex: 0 0 100%;
    }
  }
  /deep/.el-card__header {
    background-color: #f5f5f5;
  }
  .ml-30 {
    margin-left: 30px;
  }
  .mr-10 {
    margin-right: 10px;
  }
}
</style>

<template>
  <div
    class="member-order-refund"
    style="width:1100px;margin:0 auto;overflow-x:auto;"
  >
    <div class="member-order-header">
      <h2 class="solid-bottom padding-bottom">{{ type == 'detail' ? '退款详情' : '申请退款'}}</h2>
      <div class="flex row margin-top">
        <span>订单号: {{ order.orderSn }}</span>
        <span class="margin-left-xl">下单时间:{{ order.createdAt }}</span>
        <span class="margin-left-xl">支付方式:{{ $enums.payments.label(order.payMethod) }}</span>
      </div>
      <div class="margin-top flex col order-product-list member-order" v-if="showRefundInfo()">
        <el-card>
          <div slot="header">
            <span>寄回信息:</span>
          </div>
          <div style="padding: 20px 0">
            <span>寄回地址: 广州市黄埔区开创大道1505号3F    梁健怡     020-82220488-885</span>
          </div>
          <div>
            <span class="mr-10">快递公司:</span>
            <el-input style="width: 200px" v-model="expressName" placeholder="请输入内容"></el-input>
            <span class="ml-30 mr-10">快递单号:</span>
            <el-input style="width: 200px" v-model="expressNumber" placeholder="请输入内容"></el-input>
          </div>
        </el-card>
      </div>
      <div class="margin-top flex col order-product-list member-order">
        <el-card>

          <div
            class="member-order-product-list-header"
            slot="header"
          >
            <div class="order-product-list-header">
              <div class="order-product-detailed">商品清单</div>
              <div class="order-product-number">数量</div>
              <div class="order-product-price">单价</div>
            </div>
          </div>

          <div class="member-order-list">
            <div class="order-product-list">
              <div
                class="order-product-item"
                v-for="(orderProduct, index) of order.orderProducts"
                :key="index"
              >
                <div class="order-product-detailed">
                  <img
                    :src="orderProduct.image"
                    class="order-product-image"
                    alt=""
                  >
                  <div>{{orderProduct.productName}}</div>
                </div>
                <div class="order-product-number">
                  {{orderProduct.number}}
                </div>
                <div class="order-product-price">
                  ¥{{orderProduct.salePrice}}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div class="member-card margin-top">
        <el-card>
          <div
            slot="header"
            class="flex row flex-sb padding-lr-xl"
          >
            <span>退款信息</span>
            <span v-if="type == 'detail' && order && order.refundRecord">{{ $enums.refundStatus.label(order.refundRecord.status ) }}</span>
          </div>
          <div class="flex col">
            <div class="flex row padding-tb-sm flex-cc">
              <span>退款原因:</span>
              <span
                v-if="type == 'detail' && order && order.refundRecord"
                class="margin-left"
              >{{ order.refundRecord.reason}}</span>
              <el-select
                v-else-if="reasons && reasons.length"
                class="margin-left"
                v-model="reason"
              >
                <el-option
                  v-for="(item, index) in reasons"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div
              class="flex row  padding-tb-sm flex-cc"
              v-if="type == 'detail'"
            >
              <span>申请时间:</span>
              <span class="margin-left">{{ order && order.refundRecord && order.refundRecord.createdAt }}</span>
            </div>
            <div class="flex row  padding-tb-sm flex-cc">
              <span>退还渠道:</span>
              <span class="margin-left">{{ $enums.payments.label(order.payMethod) }}</span>
            </div>
            <div class="flex row padding-tb-sm flex-cc">
              <span>退款金额:</span>
              <span class="margin-left">{{ order.orderAmount }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <div class="margin-top flex col order-product-list member-order" v-if="showRefundCompleteInfo()">
        <el-card>
          <div slot="header">
            <span>寄回信息: </span>
          </div>
          <div style="padding: 20px 0">
            寄回地址: 广州市黄埔区开创大道1505号3F    梁健怡     020-82220488-885
          </div>
          <div>
            <span>快递公司: {{order.refundRecord.expressName}}</span>
            <span class="ml-30">快递单号: {{order.refundRecord.expressNumber}}</span>
          </div>
        </el-card>
      </div>

      <div v-if="!showRefundInfo()">
        <div
          v-if="showCancelButton"
          class="flex flex-center margin-top-xl"
        >
          <el-button
            style="width:200px;"
            type="info"
            @click="cancel"
          >取消退款</el-button>
        </div>
        <div
          v-else-if="type == 'confirm'"
          class="flex flex-center margin-top-xl"
        >
          <el-button
            :loading="isSubmit"
            style="width:200px;"
            type="primary"
            @click="submit"
          >提交申请</el-button>
        </div>
      </div>
      <div v-else>
        <div
          class="flex flex-center margin-top-xl"
        >
          <el-button
            style="width:200px;"
            type="info"
            @click="cancel"
          >取消退款</el-button>
          <el-button
            style="width:200px;"
            type="primary"
            class="ml-30"
            @click="submitRefund"
          >提交寄回信息</el-button>
        </div>
      </div>   
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('refund')

export default {
  data() {
    return {
      order: {

      },
      type: '',
      reason: null,
      isSubmit: false,
      expressNumber: '',
      expressName: ''
    }
  },
  computed: {
    ...mapState(['reasons']),

    showCancelButton() {
      if (this.type == 'detail' && this.order && this.order.refundRecord && this.$enums.refundStatus.RO_UNSETTLED == this.order.refundRecord.status) {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions(['changeRefundOrderStatus']),
    showRefundInfo() {
      if(this.order.refundRecord&&this.order.refundRecord.status === 4) return true
      return false
    },
    showRefundCompleteInfo() {
      if(this.order.refundRecord&&(this.order.refundRecord.status === 5||this.order.refundRecord.status === 2)&&this.order.refundRecord.expressName) return true
      return false
    },
    async getOrder(id) {
      const { document } = await this.$store.dispatch('orders/document', id);
      this.order = document
    },

    async loadReasons() {
      await this.$store.dispatch('refund/loadReasons');
      if (this.reasons && this.reasons.length) {
        this.reason = this.reasons[0]
      }
    },

    async cancel() {
      try {
        await this.$confirm('确定取消当前退款申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })

        await this.changeRefundOrderStatus({
          id: this.order.refundRecord.id,
          status: this.$enums.refundStatus.RO_CANCELLED
        })
        this.getOrder(this.order.id)
      } catch (error) {
        if (error.code == "5030" || error.code == "5033") {
          // 订单已经发货 订单已退款
          this.$router.replace({
            name: 'member-order-detail',
            params: {
              id: this.order.id
            }
          })
        } else {
          this.getOrder(this.order.id)
        }
      } finally {

      }
    },
    async submitRefund() {
      if (!this.expressName) {
        this.$message.warning('请输入快递公司名称')
        return
      }
      if (!this.expressNumber) {
        this.$message.warning('请输入快递单号')
        return
      }
      try {
        await this.$store.dispatch('refund/refundOrderInfo', {
          id: this.order.refundRecord.id,
          // status: 5,
          expressName: this.expressName,
          expressNumber: this.expressNumber
        })   
        this.$message.success('提交成功')
        setTimeout(() => {
          this.type = 'detail'
          this.getOrder(this.order.id)
          this.$router.replace({
            name: 'member-order-refund-detail',
            params: {
              id: this.order.id
            }
          })
        }, 1000)
      } catch (error) {
        console.log(error) 
      }
    },
    async submit() {
      if (this.isSubmit) return
      try {
        this.isSubmit = true
        await this.$store.dispatch('refund/refundOrder', {
          orderId: this.order.id,
          reason: this.reason
        })

        this.$message.success('提交成功')
        setTimeout(() => {
          this.type = 'detail'
          this.getOrder(this.order.id)
          this.$router.replace({
            name: 'member-order-refund-detail',
            params: {
              id: this.order.id
            }
          })
        }, 1000)

      } catch (error) {
        if (error.code == "5030" || error.code == "5033") {
          // 订单已经发货 订单已退款
          this.$router.replace({
            name: 'member-order-detail',
            params: {
              id: this.order.id
            }
          })
        } else if (error.code == "5031") {
          // 订单已经申请
          this.type = 'detail'
          this.getOrder(this.order.id)
          this.$router.replace({
            name: 'member-order-refund-detail',
            params: {
              id: this.order.id
            }
          })
        }
        console.log(error.code)
        console.log(error)
      } finally {
        this.isSubmit = false
      }

    },
  },
  mounted() {
    const orderId = this.$route.params.id
    const { type } = this.$route.meta
    this.type = type
    this.getOrder(orderId);
    this.loadReasons()
  },
}
</script>